import { FC, useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { PageDataProvider } from './core'
import {
    DrawerComponent,
    MenuComponent,
    ScrollComponent,
    ScrollTopComponent,
    SwapperComponent,
    ToggleComponent
} from '../assets/ts/components'
import { WithChildren } from '../helpers'
import { PublicHeaderWrapper } from './publicPagesComponent/HeaderWrapper'
import WidgetBar from './publicPagesComponent/widgetbar'
import '../assets/css/publicPages.css';



const PublicPageLayout: FC<WithChildren> = () => {
    const location = useLocation()

    useEffect(() => {
        const timeout = setTimeout(() => {
            ToggleComponent.reinitialization();
            ScrollTopComponent.reinitialization();
            DrawerComponent.reinitialization();
            MenuComponent.reinitialization();
            ScrollComponent.reinitialization();
            SwapperComponent.reinitialization();

            (window as any)?.KTMenu?.createInstances?.();
        }, 0);

        return () => clearTimeout(timeout);
    }, [location.pathname]);

    const isHomePage =
        location.pathname === '/pages/home' ||
        location.pathname === '/pages/home/';

    return (
        <PageDataProvider>
            <div className='public-pages wrapper d-flex flex-column vh-100 overflow-hidden' id='kt_wrapper'>
                <PublicHeaderWrapper />
                <div
                    className='flex-grow-1 d-flex flex-column overflow-hidden'
                    id='kt_Content_wrapper'
                >
                    <div className="flex-grow-1 d-flex flex-column overflow-hidden">
                        <Outlet />
                    </div>
                </div>
                {!isHomePage && <WidgetBar />}
            </div>
        </PageDataProvider>
    )
}

export { PublicPageLayout }